import { render, staticRenderFns } from "./AiPhraseRecordFilter.vue?vue&type=template&id=7863bb2c&scoped=true&"
import script from "./AiPhraseRecordFilter.vue?vue&type=script&lang=ts&"
export * from "./AiPhraseRecordFilter.vue?vue&type=script&lang=ts&"
import style0 from "./AiPhraseRecordFilter.vue?vue&type=style&index=0&id=7863bb2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7863bb2c",
  null
  
)

export default component.exports